const UrlConfigTable = ({
  sourceData,
  isNeedAddRec,
  changeUsage,
  setNewValues,
  newValues,
  handleAddClick,
}) => {
  return (
    <>
      <div className="admin_table-container">
        <table className="admin_config-table">
          <thead className="admin_config-table">
            <tr>
              <th>Наименование</th>
              <th>Url</th>
              <th>Используется</th>
            </tr>
          </thead>
          <tbody className="admin_config-table">
            {sourceData.map((item, ind) => (
              <tr key={`url-${ind}`}>
                <td>{item.name}</td>
                <td
                  style={{
                    width: "max-content",
                    maxWidth: "calc((50vw - 80px) / 3)",
                    overflowX: "auto",
                  }}
                >
                  {item.data}
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={item.is_used}
                    onChange={(e) => changeUsage(item.name, e.target.checked)}
                  />
                </td>
              </tr>
            ))}
            {isNeedAddRec && (
              <tr>
                <td>
                  <input
                    type="text"
                    placeholder="Введите имя конфига"
                    onChange={(e) =>
                      setNewValues(
                        Object.assign({}, newValues, {
                          name: e.target.value,
                        })
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Введите url"
                    onChange={(e) =>
                      setNewValues(
                        Object.assign({}, newValues, {
                          data: e.target.value,
                        })
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={newValues.is_used || false}
                    onChange={(e) =>
                      setNewValues(
                        Object.assign({}, newValues, {
                          is_used: e.target.checked,
                        })
                      )
                    }
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <button className="report_button" onClick={handleAddClick}>
          {!isNeedAddRec ? "Добавить ссылку" : "Сохранить"}
        </button>
      </div>
    </>
  );
};

export default UrlConfigTable;
